import { Property } from '@skylab-shared/core';
import { ClientOtherBuyerRole } from '../client/client-other-buyer-role';
import { DocumentClientModel } from './document-client.model';

export class DocumentBuyerModel extends DocumentClientModel {
	@Property(String, {nullable: true})
	public role: ClientOtherBuyerRole | null;
}
